export default __webpack_public_path__ + "locales/az/FilesSettings.json?hash=c6f7e4d01393f64fd8264e60ccea2bc3";